function ordenarTalhoes(talhoes) {
    return [...talhoes].sort((a, b) => {
        const nomeA = parseInt(a.nome);
        const nomeB = parseInt(b.nome);

        if (nomeA < nomeB) return -1;
        if (nomeA > nomeB) return 1;
        return 0;
    });
}

function juntarComE(valores) {
    if (valores.length <= 1) return valores.join("");
    return `${valores.slice(0, -1).join(", ")} e ${valores[valores.length - 1]}`;
}

function formatarArea(area) {
    const numero = Number(area);
    if (!Number.isFinite(numero) || numero <= 0) return "";
    return `${numero.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ha`;
}

/**
 * Retorna o(s) nome(s) do(s) talhão(ões) do apontamento, já ordenados e
 * concatenados com "e" no último item (ex: "1, 2 e 3").
 */
export function getTalhaoNomeDisplay(apontamento) {
    if (apontamento.talhao?.length) {
        const ordenados = ordenarTalhoes(apontamento.talhao);
        return juntarComE(ordenados.map((t) => t.nome));
    }
    return apontamento.talhao?.nome || "";
}

/**
 * Retorna a área do(s) talhão(ões) do apontamento, em hectares.
 * Quando há mais de um talhão, mostra o valor individual de cada um
 * (não soma), na mesma ordem usada em getTalhaoNomeDisplay.
 */
export function getTalhaoAreaDisplay(apontamento) {
    if (apontamento.talhao?.length) {
        const ordenados = ordenarTalhoes(apontamento.talhao);
        const areas = ordenados.map((t) => formatarArea(t.area)).filter(Boolean);
        return areas.length ? juntarComE(areas) : "";
    }
    return formatarArea(apontamento.talhao?.area);
}
